import { useMutation, useQuery, useQueryClient } from "react-query";

import Alert from "components/atoms/alert/Alert";

import {
    deletePaymentBillingKey,
    getPaymentBillingKeyList,
    getPaymentCoupon,
    getPaymentDiscountPolicy,
    getPaymentPlan,
    postPaymentBillingKey,
    registerPaymentCoupon,
} from "utils/request/payment";
import {
    getSpacePaymentHistory,
    postGroupSubscription,
    postGroupSubscriptionRollback,
    postSpacePaymentHistory,
} from "utils/request/space";

export const usePaymentBillingKeys = (params) => {
    return useQuery("paymentBillingKey", (e) => getPaymentBillingKeyList(params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const usePaymentBillingKeyCreate = () => {
    const queryClient = useQueryClient();

    return useMutation(postPaymentBillingKey, {
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: "paymentBillingKey" });
        },
    });
};

export const usePaymentBillingKeyDelete = () => {
    const queryClient = useQueryClient();

    return useMutation(deletePaymentBillingKey, {
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: "paymentBillingKey" });
        },
    });
};

export const useSpacePaymentHistory = (space_uuid, params, options = {}) => {
    return useQuery(
        ["spacePaymentHistory", space_uuid, params],
        (e) => getSpacePaymentHistory({ space_uuid, params }),
        {
            staleTime: Infinity,
            cacheTime: Infinity,
            retry: false,
            enabled: Boolean(space_uuid),
            ...options,
        },
    );
};

export const useSpacePaymentHistoryCreate = () => {
    const queryClient = useQueryClient();

    return useMutation(postSpacePaymentHistory, {
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: "user" });
            queryClient.invalidateQueries({ queryKey: "space" });
            queryClient.invalidateQueries({ queryKey: "spacePaymentHistory" });
            queryClient.invalidateQueries({ queryKey: "paymentCoupon" });
        },
    });
};

export const useGroupSubscriptionCreate = () => {
    const queryClient = useQueryClient();

    return useMutation(postGroupSubscription, {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: "user" });
            queryClient.invalidateQueries({ queryKey: "space" });
            queryClient.invalidateQueries({ queryKey: "spacePaymentHistory" });
        },
    });
};

export const useGroupSubscriptionRollback = () => {
    const queryClient = useQueryClient();

    return useMutation(postGroupSubscriptionRollback, {
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: "user" });
            queryClient.invalidateQueries({ queryKey: "space" });
            queryClient.invalidateQueries({ queryKey: "spacePaymentHistory" });
        },
    });
};

export const usePaymentPlan = () => {
    return useQuery("paymentPlan", (e) => getPaymentPlan(), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const usePaymentCoupon = (params) => {
    return useQuery("paymentCoupon", (e) => getPaymentCoupon(params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const usePaymentCouponRegister = () => {
    const queryClient = useQueryClient();

    return useMutation(registerPaymentCoupon, {
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: "paymentCoupon" });
            Alert("info", "쿠폰", "쿠폰이 등록되었습니다.");
        },
        onError: (e) => {
            if (e.response.data.error) {
                Alert("warn", "에러", e.response.data.error);
            } else {
                Alert("warn", "에러", "서버에 오류가 발생하였습니다.");
            }
        },
    });
};

export const usePaymentDiscountPolicy = () => {
    return useQuery("paymentDiscountPolicy", (e) => getPaymentDiscountPolicy(), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};
